import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { InvoiceComponent } from 'src/app/components/invoice/invoice.component';
import { InvoiceViewComponent } from 'src/app/components/invoice/view/view.component';
import { InvoicePayComponent } from 'src/app/components/invoice/payment/payment.component';
import { InvoiceSuccessComponent } from 'src/app/components/invoice/confirmation/confirmation.component';

import { ValidInvoiceTrackingIDGuard } from 'src/app/guards/valid-invoice-tracking-id-guard.service';
import { StepperRouteGuard } from 'src/app/guards/stepper-route-guard.service';
import { ErrorComponent } from './core/components/error/error.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'error',
  },
  {
    path: 'invoice/:invoiceTrackingKey',
    component: InvoiceComponent,
    canActivate : [ValidInvoiceTrackingIDGuard],
    children: [
      {
          path: '',
          pathMatch: 'full',
          component: InvoiceViewComponent,
          canActivate : [StepperRouteGuard],
          data: {stepName: ''},
      },
      {
          path: 'payment',
          pathMatch: 'full',
          component: InvoicePayComponent,
          canActivate : [StepperRouteGuard],
          data: {stepName: 'payment'},
      },
      {
          path: 'confirmation',
          pathMatch: 'full',
          component: InvoiceSuccessComponent,
          canActivate : [StepperRouteGuard],
          data: {stepName: 'confirmation'},
      },
    ]
  },
  {
    path: 'error',
    pathMatch: 'full',
    component: ErrorComponent
  },
  {
    path: '**',
    redirectTo: 'error',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
